import {
  InputGroup,
  InputRow,
  EmptyInput,
  ModelNewNumericInput,
} from '@equifinance/shared';

import { PaddedSection } from '../../components/Section';
import { useAccountContext } from '../../../../contexts';

export const IncomeRefName = 'income';

export default function IncomeSection() {
  const { account } = useAccountContext();

  const {
    income,
    errors,
    warnings,
  } = account;

  const { version } = income;

  return (
    <PaddedSection
      id={income?.id}
      refName={IncomeRefName}
      title="Income"
      errors={errors}
      warnings={warnings}
    >
      <InputGroup>
        <InputRow>
          <ModelNewNumericInput
            label="Total household gross monthly income from all sources"
            field="income.totalHouseholdGrossMonthlyIncome"
            prefix="£"
            isFixedDecimal
            required
            maxCharacters={10}
            tooltip="Include income from all employment / self-employment and other regular monthly sources e.g benefits, pensions, maintenance, rental etc."
          />
          {version > 1
            ? (
              <ModelNewNumericInput
                label="Total household net monthly income"
                field="income.totalHouseholdNetMonthlyIncome"
                prefix="£"
                isFixedDecimal
                required
                maxCharacters={10}
                tooltip="Include income from all employment / self-employment and other regular monthly sources e.g benefits, pensions, maintenance, rental etc"
              />
            ) : <EmptyInput />}
        </InputRow>
      </InputGroup>
    </PaddedSection>
  );
}
